module.exports = __webpack_public_path__ + "img/arrows.8e9e2657.svg";